import api from '../services/api';

export default async function getVideos(url, pesquisa) {

  return api
    .get(url, 
    {
      headers: { 'Content-Type': 'application/json', },
      params:{pesquisa: pesquisa}
    })
    .then(response => {
      return {type: 'success', data: response.data};
    })
    .catch(error => {
      return {type:'error', data: {code: error.response.data.code, detail: error.response.data.detail}}
    });
}
